import React from 'react';
import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_first_name',
    title: 'First name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_middle_name',
    title: 'Middle initial',
    is_required: false,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[a-zA-Z]{1}$',
        customErrorMessage: 'The middle initial can only contain 1 letter.',
      },
    ],
  },
  {
    id: 'employee_last_name',
    title: 'Last name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Home address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
  {
    id: 'filing_status',
    title: 'Please select filing status: (Line 1)',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'single_or_married',
        shortName: 'Single, or married but legally separated, or your spouse is a non-U.S. citizen without permanent resident status',
      },
      {
        codeValue: 'married',
        shortName: 'Married',
      },
      {
        codeValue: 'married_at_single_rate',
        shortName: 'Married, but withhold at a higher single rate',
      },
    ],
  },
];

export const allowancesQuestionsData = [
  {
    id: 'total_num_allowances',
    title:
  <div>
    Enter the total number of allowances you&apos;re claiming from on line A4, B15, or C5.
    {' '}
    <a href="https://www.oregon.gov/dor/forms/FormsPubs/form-or-W-4-instr_101-402-1_2025.pdf" target="_blank" rel="noreferrer">See worksheets in the instructions.</a>
    {' '}
    If you skip the worksheets and aren&apos;t exempt, enter 0. (Line 2)
  </div>,
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
  {
    id: 'additional_withholding',
    title: 'Additional amount, if any, you want withheld each paycheck. (Line 3)',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^[0-9]+(.[0-9]{1,2})?$',
      },
    ],
  },
];

export const exemptionQuestions = [
  {
    id: 'exemption_reason',
    title: 'Select a qualification for having no tax liability (Line 4a)',
    question_type: 'dropdown',
    is_required: true,
    options: [
      {
        codeValue: 'air_carrier',
        shortName: 'Air carrier employee',
      },
      {
        codeValue: 'american_indian',
        shortName: 'American Indian enrolled tribal member living and working in Indian country in Oregon.',
      },
      {
        codeValue: 'amtrak_worker',
        shortName: 'Amtrak Act worker',
      },
      {
        codeValue: 'casual_laborer',
        shortName: 'Casual laborer',
      },
      {
        codeValue: 'domestic_service_worker',
        shortName: 'Domestic service worker',
      },
      {
        codeValue: 'dam_worker',
        shortName: 'Hydroelectric dam worker at the Bonneville, John Day, McNary, or The Dalles dams.',
      },
      {
        codeValue: 'military_pay',
        shortName: 'Military pay for nonresidents stationed in Oregon and their spouses, residents stationed outside Oregon, and service members whose Defense Finance and Accounting Services (DFAS) address is outside Oregon.',
      },
      {
        codeValue: 'minister_ordained',
        shortName: 'Minister who is duly ordained, commissioned, or licensed and performing duties in their ministry or a member of a religious order performing duties required by their order',
      },
      {
        codeValue: 'real_estate_under_contract',
        shortName: 'Real estate salesperson under a written contract not to be treated as an employee.',
      },
      {
        codeValue: 'waterway_worker',
        shortName: 'Waterway worker',
      },
      {
        codeValue: 'no_tax_liability',
        shortName: 'No tax liability - Last year you had the right to a refund of all Oregon tax withheld because you had no tax liability, and this year you expect a refund of all Oregon income tax withheld because you expect to have no tax liability.',
      },
      {
        codeValue: 'nonresident',
        shortName: 'Nonresident who expects a refund of all Oregon income tax withheld because their wages won’t be subject to Oregon tax.',
      },
    ],
  },
];
